import { InfoCircle } from '@/assets/icons'
import { kResponseCanceledMessage } from '@/constants/constants-strings'

/**
 * Response Canceled Event Bubble
 *
 * A component to display an event of type STOP_REQUEST_RECEIVED, indicating that the response was
 * canceled by the user before completion.
 */
export default function ResponseCanceledEventBubble() {
  return (
    <div className="flex items-center p-3 rounded-md text-brand-neutral-700 bg-brand-neutral-100 border border-brand-neutral-300">
      <span className="flex items-center justify-center rounded-lg mr-2">
        <InfoCircle fontSize="small" />
      </span>
      <div className="text-sm">{kResponseCanceledMessage}</div>
    </div>
  )
}
